import type { SavedViewSection } from './types'

/**
 * Maps a URL pathname to its corresponding saved-view section. Routes are
 * matched in priority order (insights, community, create, publish) so that
 * nested paths like `/channels/:id/community` resolve to `community` instead
 * of `publish`.
 */
export function deriveSectionFromRoute(pathname: string): SavedViewSection {
  if (/^\/(insights|analytics)(\/|$)/.test(pathname)) {
    return 'insights'
  }

  if (
    /^\/community(\/|$)/.test(pathname) ||
    /^\/comments(\/|$)/.test(pathname) ||
    /^\/channels\/[^/]+\/community(\/|$)/.test(pathname) ||
    /^\/channels\/[^/]+\/comments(\/|$)/.test(pathname)
  ) {
    return 'community'
  }

  if (/^\/create(\/|$)/.test(pathname) || /^\/ideas(\/|$)/.test(pathname)) {
    return 'create'
  }

  return 'publish'
}
